module.exports = __webpack_public_path__ + "banner-credito-carro.png";